(() => {
  const DISCOUNT_SELECTOR =
    ".product-single__meta .discount-coupon .discount-coupon__content p, .product-single__meta .discount-coupon .discount-coupon__content";
  const APPLIED_TEXT = "Your discount has been applied";
  let originalText = null;
  let activatedBound = false;

  function discountElement() {
    return document.querySelector(DISCOUNT_SELECTOR);
  }

  function markDiscountApplied() {
    const el = discountElement();
    if (!el) return;
    if (originalText == null) originalText = el.textContent;
    el.textContent = APPLIED_TEXT;
  }

  function restoreDiscountCopy() {
    const el = discountElement();
    if (!el || originalText == null) return;
    el.textContent = originalText;
  }

  function bannerTarget() {
    const rebuyVisible = document.querySelector(
      ".rebuy-cart.is-visible .rebuy-cart__flyout-items"
    );
    if (rebuyVisible) return rebuyVisible;

    if (document.body.classList.contains("template-cart")) {
      return document.querySelector(".cart__page-col");
    }

    return null;
  }

  function stampVariantForAbra(variant) {
    if (!variant || !variant.id) return;

    const id = String(variant.id);
    document.querySelectorAll("[data-section-type='product']").forEach((root) => {
      root.setAttribute("data-variant-id", id);
      root
        .querySelectorAll(
          '[id^="ProductPrice"], .product-price-wrapper, .product-block--price, .product-single__meta, form[action*="/cart/add"]'
        )
        .forEach((el) => el.setAttribute("data-variant-id", id));
    });
  }

  function stampCurrentProductVariant() {
    const root = document.querySelector("[data-section-type='product']");
    if (!root) return;
    stampVariantForAbra({ id: root.getAttribute("data-variant-id") });
  }

  function requestAbraRender() {
    requestAnimationFrame(() => {
      window.dispatchEvent(new CustomEvent("abra:render"));
    });
  }

  function getOrCreateBannerContainer() {
    const existing = document.getElementById("AbraCartDrawerBannerContainer");
    if (existing) return existing;

    const tpl = document.getElementById("AbraCartDrawerBannerTemplate");
    const source = tpl && tpl.content && tpl.content.firstElementChild;
    if (!source) return null;

    return source.cloneNode(true);
  }

  function placeAbraCartBanners() {
    const target = bannerTarget();
    if (!target) return;

    const container = getOrCreateBannerContainer();
    if (!container || container.parentElement === target) return;

    target.insertBefore(container, target.firstChild);
    window.dispatchEvent(new CustomEvent("abra:render"));
  }

  function itemHidesQuantity(item) {
    const props = (item && item.properties) || {};
    return Boolean(props.__hide_quantity || props._abra_bundle);
  }

  function lockRebuyAbraLines() {
    const cart = window.Rebuy && Rebuy.Cart && Rebuy.Cart.cart;
    if (!cart || !Array.isArray(cart.items)) return;

    cart.items.forEach((item) => {
      if (!itemHidesQuantity(item)) return;

      const matches = document.querySelectorAll(
        [
          '.rebuy-cart__flyout-item[data-key="' + item.key + '"]',
          '.rebuy-cart__flyout-item[data-variant-id="' + item.variant_id + '"]',
          '.rebuy-cart__flyout-item[data-product-id="' + item.product_id + '"]',
        ].join(",")
      );

      matches.forEach((el) => {
        el.setAttribute("data-abra-hide-qty", "true");
        const qty = el.querySelector(
          ".rebuy-cart__flyout-item-quantity, .rebuy-cart__flyout-item-quantity-widget"
        );
        if (qty) qty.hidden = true;
      });
    });
  }

  function refreshCartsAfterAbraChange() {
    document.dispatchEvent(new CustomEvent("cart:build"));
    placeAbraCartBanners();

    if (
      window.Rebuy &&
      Rebuy.Cart &&
      typeof Rebuy.Cart.fetchShopifyCart === "function"
    ) {
      Rebuy.Cart.fetchShopifyCart(() => {
        lockRebuyAbraLines();
        placeAbraCartBanners();
      });
    } else {
      lockRebuyAbraLines();
    }

    window.dispatchEvent(new CustomEvent("abra:render"));
  }

  function bindActivatedListeners() {
    if (activatedBound) return;
    activatedBound = true;

    if (window.Abra && typeof window.Abra.addListener === "function") {
      window.Abra.addListener("activated", markDiscountApplied);
      window.Abra.addListener("deactivated", restoreDiscountCopy);
    }
  }

  function storefrontPromotionTitle() {
    const code = window.discount && window.discount.code;
    return code ? String(code).trim() : "";
  }

  function promotionAlreadyActive() {
    return (
      document.body.classList.contains("abra--activated") ||
      document.body.classList.contains("abra--applied")
    );
  }

  function maybeActivateStorefrontPromotion() {
    if (promotionAlreadyActive()) {
      markDiscountApplied();
      return;
    }

    const title = storefrontPromotionTitle();
    if (!title || !window.Abra || typeof window.Abra.activate !== "function") {
      return;
    }

    // Replaces Intelligems: Abra.activate(window.discount.code) on abra:initialized
    Promise.resolve(window.Abra.activate(title, undefined, { passive: true }))
      .then((ok) => {
        if (ok) {
          markDiscountApplied();
          requestAbraRender();
        }
      })
      .catch(() => {});
  }

  // Replaces Intelligems: Rebuy.SmartCart.applyDiscount(window.discount.code)
  // on rebuy:smartcart.ready. Code comes from shop.metafields.store.discount_code
  // (set as window.discount in theme.liquid) — not from Intelligems.
  function applyStorefrontDiscountToRebuy() {
    const code = storefrontPromotionTitle();
    if (!code) return;

    const smartCart = window.Rebuy && Rebuy.SmartCart;
    if (!smartCart || typeof smartCart.applyDiscount !== "function") return;

    if (
      typeof smartCart.shouldApplyDiscountCode === "boolean" &&
      !smartCart.shouldApplyDiscountCode
    ) {
      return;
    }

    try {
      smartCart.applyDiscount(code);
    } catch (e) {}
  }

  function onSmartCartReady() {
    placeAbraCartBanners();
    lockRebuyAbraLines();
    applyStorefrontDiscountToRebuy();
  }

  function onAbraInitialized() {
    stampCurrentProductVariant();
    bindActivatedListeners();
    requestAbraRender();
    maybeActivateStorefrontPromotion();
  }

  function ensureAbraSdk() {
    if (window.Abra) return;

    const local = [...document.scripts].find(
      (s) =>
        /127\.0\.0\.1|localhost/.test(s.src) &&
        /\/cdn\/extensions\/.+\/assets\/abra\.js/.test(s.src)
    );
    if (!local) return;

    const match = local.src.match(/\/cdn\/extensions\/(.+)$/);
    if (!match) return;

    const s = document.createElement("script");
    s.src = "https://cdn.shopify.com/extensions/" + match[1];
    s.async = true;
    document.head.appendChild(s);
  }

  window.addEventListener("abra:activated", markDiscountApplied);
  window.addEventListener("abra:unapplied", restoreDiscountCopy);
  window.addEventListener("abra:initialized", onAbraInitialized);

  if (document.body.classList.contains("abra--initialized")) {
    onAbraInitialized();
  } else {
    ensureAbraSdk();
  }

  window.addEventListener("abra:cart:changed", refreshCartsAfterAbraChange);

  document.addEventListener("variant:change", (event) => {
    stampVariantForAbra(event.detail && event.detail.variant);
    requestAbraRender();
  });

  document.addEventListener("rebuy:smartcart.show", () => {
    placeAbraCartBanners();
    lockRebuyAbraLines();
    window.dispatchEvent(new CustomEvent("abra:render"));
  });

  document.addEventListener("rebuy:smartcart.ready", onSmartCartReady);

  if (
    window.Rebuy &&
    Rebuy.SmartCart &&
    Rebuy.SmartCart.status === "ready"
  ) {
    onSmartCartReady();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", placeAbraCartBanners);
  } else {
    placeAbraCartBanners();
  }
})();
